import { IMAGE_EXT_REGEX, YOUTUBE_EMBED_URL_PARTIAL, YOUTUBE_REGEX } from './constants';

export function getYoutubeEmbedUrl(id) {
  if (typeof id === 'string') {
    return [YOUTUBE_EMBED_URL_PARTIAL, id ?? ''].join('');
  }
  return null;
}

export function getYoutubeId(url) {
  if (YOUTUBE_REGEX.test(url)) {
    const results = url.match(YOUTUBE_REGEX);
    return (results ?? []).pop();
  }
  return null;
}

export function objectHasKey(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj ?? {}, key ?? '');
}

export function formatAsJSONString(obj, space = 4) {
  return JSON.stringify(obj, { encoding: 'utf-8', flag: 'a+' }, space);
}

export function withStoryblokHeaderImgResize(imgUrl) {
  if (IMAGE_EXT_REGEX.test(imgUrl)) {
    return `${imgUrl}/m/1250x625/smart`;
  }
  return null;
}

export function isEmpty(value) {
  return !!(value == null || value.length <= 0);
}

export function getCurrentDate() {
  const datenow = new Date().toISOString();
  return `${datenow.substring(0, 10)} 23:59`;
}
